import React from "react"
import classnames from "classnames"
import { isEmpty } from "lodash"
import { useDispatch, useSelector } from "react-redux"
import { setBookMarkedLists, UpdateBookMarkedLists } from "store/actions"

const Actions = ({
  Reporticon,
  Imageicon,
  fullviewteamreport,
  renderWorkStatus,
  projectreport,
  row,
  selectToggle,
  isMobile,
  summaryDatateam,
  handleverifyScreenrow,
  summaryData,
  handleverifyScreenproject,
  loadTeamScreenteam
}) => {
  const renderDataList = !selectToggle
    ? row?.timeSheetReports
    : row?.projectTimeSheet
  const FilteredKey = !selectToggle ? "projects" : "user"

  const bookmarkedLists = useSelector(state => state?.teams?.bookmarkedLists)
  const isBookMarked = (bookmarkedLists || []).findIndex(ele => row.projectId === ele.projectId) > -1
  const dispatch = useDispatch()
  const toggleBookMarks = (e) => {    
    e.stopPropagation()
    let postReq = {
      userId: JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id,
      subcategoryid: row?.projectId,
      isFavorite: !isBookMarked
    }
    dispatch(UpdateBookMarkedLists(postReq), loadTeamScreenteam());
    const checkAlreadyExists = bookmarkedLists.filter(
      ele => ele?.projectId === row?.projectId
    )
    if (!isEmpty(checkAlreadyExists)) {
      const FilteredLists = bookmarkedLists.filter(
        ele => ele?.projectId !== row?.projectId
      )
      dispatch(setBookMarkedLists(FilteredLists))
    } else {
      const AddedCheckedLists = [...bookmarkedLists, row]
      dispatch(setBookMarkedLists(AddedCheckedLists))
    }
  }

  return (
    <div className={`${isMobile ? "" : "d-flex justify-content-center"}`}>
      <span
        className={classnames("me-3 hovertext")}
        data-hover="Active Summary"
      >
        <img
          src={Reporticon}
          alt={Reporticon}
          style={{ cursor: "pointer" }}
          onClick={e => {
            e.stopPropagation()
            selectToggle ? summaryData(row) : summaryDatateam(row)
          }}
        />
      </span>
      <span
        className={classnames("me-3 hovertext")}
        data-hover="Verify Screens"
      >
        <img
          src={Imageicon}
          style={{ cursor: "pointer", zIndex: "999" }}
          alt={Imageicon}
          onClick={e => {
            e.stopPropagation()
            !selectToggle
              ? handleverifyScreenproject(row)
              : handleverifyScreenrow(row)
          }}
        />
      </span>
      {!selectToggle && (
        <>
          {projectreport && (
            <span
              className={classnames("me-3 hovertext")}
              data-hover="Project Screens"
            >
              <img
                src={projectreport}
                alt={projectreport}
                width={19}
                height={19}
                style={{ cursor: "pointer" }}
                onClick={e => {
                  e.stopPropagation()
                  fullviewteamreport && fullviewteamreport(row)
                }}
              />
            </span>
          )}
        </>
      )}
      {!selectToggle && (
        <>
          {renderWorkStatus(renderDataList, FilteredKey) ? (
            <span className="me-2">
              <i
                className="fas fa-check"
                style={{
                  fontSize: "18px",
                  color:
                    renderWorkStatus(renderDataList, FilteredKey) ===
                      "Submitted"
                      ? "green"
                      : "red",
                }}
              ></i>
            </span>
          ) : (
            <span style={{ width: "20px" }} className="me-2"></span>
          )}
        </>
      )}
      {projectreport && <span className={classnames("me-3 hovertext")}
        data-hover="Bookmark">
        <i
          className={classnames("fas fa-star mb-2 me-2", isBookMarked ? "text-primary" : "text-lightgray")}
          style={{ fontSize: "16px", cursor: "pointer", opacity: isBookMarked ? 1 : 0.15 }}
          onClick={e => toggleBookMarks(e)}>
        </i>
      </span>}
    </div>
  )
}
export default Actions
